import { Route, Switch } from "react-router-dom";

import Home from './screens/Home.jsx';
import Menu from './screens/Menu.jsx';

// to display a pdf, in this case an event menu
// import ChickFeelGay from './screens/ChickFeelGay.jsx';

function App() {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/menu" component={Menu} />
       {/* <Route path="/menu" component={ChickFeelGay} /> */}
      {/* <Route path="/chickfeelgay" component={ChickFeelGay} /> */}
    </Switch>
  );
}

export default App;
